import axios, { Axios } from "axios";
import { User } from "firebase/auth";
import { ApiClient, apiResult, ApiResult } from "./dataApiClient";

declare const LIGHTSPEED_PREFIX: string;

export class LightspeedAuthApiClient implements ApiClient {
  private client: Axios;

  constructor(user: User) {
    this.client = axios.create({
      baseURL: `${API_BASE_URL}${this.getPrefixRoute()}/oseries`,
      validateStatus: () => true,
    });

    this.client.interceptors.request.use((config) => {
      return user.getIdTokenResult().then((idToken) => {
        if (!config.headers) config.headers = {};
        config.headers.Authorization = `Bearer ${idToken.token}`;
        return config;
      });
    });
  }

  getPrefixRoute(): string {
    return LIGHTSPEED_PREFIX === "local" ? "" : LIGHTSPEED_PREFIX;
  }

  async getAuthorizeUrl(
    integrationId: string
  ): Promise<ApiResult<{ AuthorizationUrl: string }>> {
    const result = await this.client.get("/authorize-url", {
      params: { integrationId },
    });
    return apiResult(result);
  }
}
